import { gql } from '@apollo/client';

export const STATION_ADDED = /* GraphQL */ gql(`
    subscription stationAdded($tenantId: String!) {
        stationAdded(tenantId: $tenantId) {
            id
            name
            description
            remotePortalId
            tenantId
        }
    }
`);

export const PLAN_MODIFIED = /* GraphQL */ `
    subscription planModified($id: String!) {
        planModified(id: $id) {
            id
        }
    }
`;

export const PLAN_CANCELED = /* GraphQL */ `
    subscription planCanceled($id: String!) {
        planCanceled(id: $id) {
            id
            planId
            cancelPlanAt
            plan {
                id
            }
        }
    }
`;

export const ACCOUNT_DELETED = /* GraphQL */ `
    subscription accountDeleted($id: String!) {
        accountDeleted(id: $id) {
            id
        }
    }
`;

export const PAYMENT_METHOD_ADDED = /* GraphQL */ `
    subscription paymentMethodAdded($tenantId: String!) {
        paymentMethodAdded(tenantId: $tenantId) {
            id
            paymentType
            expirationDate
            last4
            cardType
            default
        }
    }
`;

export const USER_ADDED = /* GraphQL */ gql(`
    subscription userAdded($tenantId: String!) {
        userAdded(tenantId: $tenantId) {
            email
            enabled
            id
            group
            groupModfified
            created
            modified
            status
            tenantId
        }
    }
`);

export const USER_DELETED = /* GraphQL */ gql(`
    subscription userDeleted($tenantId: String!) {
        userDeleted(tenantId: $tenantId) {
            id
            tenantId
        }
    }
`);

export const ROUTE_ADDED = /* GraphQL */ gql(`
    subscription routeAdded($tenantId: String!) {
        routeAdded(tenantId: $tenantId) {
            id
            name
            status
            track
            __typename
            stops {
                id
                name
                stationId
                __typename
                type
                status
                asynchronousChildren
            }
        }
    }
`);

export const ROUTE_UPDATED = /* GraphQL */ gql(`
    subscription routeUpdated($tenantId: String!) {
        routeUpdated(tenantId: $tenantId) {
            id
            name
            status
            track
            __typename
            totalStops
            actionLog {
                id
                action
                timestamp
                userId
                userEmail
                stop {
                    id
                    name
                }
            }
            stops {
                id
                name
                stationId
                __typename
                type
                status
                asynchronousChildren
            }
        }
    }
`);

export const ROUTE_DELETED = /* GraphQL */ gql(`
    subscription routeDeleted($tenantId: String!) {
        routeDeleted(tenantId: $tenantId) {
            id
            tenantId
        }
    }
`);

export const ROUTE_TEMPLATE_ADDED = /* GraphQL */ gql(`
    subscription routeTemplateAdded($tenantId: String!) {
        routeTemplateAdded(tenantId: $tenantId) {
            id
            name
            stops {
                id
                name
                type
                stationId
                asynchronousChildren
            }
            track
            description
        }
    }
`);

export const ROUTE_TEMPLATE_UPDATED = /* GraphQL */ gql(`
    subscription routeTemplateUpdated($tenantId: String!) {
        routeTemplateUpdated(tenantId: $tenantId) {
            id
            name
            stops {
                id
                name
                type
                stationId
                asynchronousChildren
            }
            track
            description
        }
    }
`);

export const ROUTE_TEMPLATE_DELETED = /* GraphQL */ gql(`
    subscription routeTemplateDeleted($tenantId: String!) {
        routeTemplateDeleted(tenantId: $tenantId) {
            id
            tenantId
        }
    }
`);
